import { QuickLinks } from './quick-links';
import { SavedSearchesService } from '../../../services/saved-searches.service';
import { Observable } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { startWith, switchMap } from 'rxjs/operators';
import { SearchParameter } from '../../../models/review/search-parameter.model';
import { SavedSearch } from '../../../models/review/saved-search.model';

export class SearchQuickLinks extends QuickLinks {

	searchControl: UntypedFormControl;
	filteredSearches: Observable<string[]>;
	private parameters: SearchParameter = new SearchParameter('');

	constructor(private savedSearchesService: SavedSearchesService) {
		super();
		this.searchControl = new UntypedFormControl();
		this.filteredSearches = this.searchControl.valueChanges.pipe(
			startWith(''),
			switchMap(prefix => this.savedSearchesService.getRecentQueries(prefix))
		);
	}

	initialize() {
		this.refresh();
	}

	refresh() {
		this.savedSearchesService.getAll().subscribe(savedSearches => {
			const arr = savedSearches.filter(v => v.isShared).sort(this.titleCompare)
				.concat(savedSearches.filter(v => !v.isShared && v.isPinned).sort(this.titleCompare))
				.concat(savedSearches.filter(v => !v.isShared && !v.isPinned).sort((a, b) => Date.parse(b.dateTimeCreated) - Date.parse(a.dateTimeCreated)));
			this.set(arr);
		});
	}

	private titleCompare(a: SavedSearch, b: SavedSearch): number {
		if (a.title < b.title) return -1;
		if (a.title > b.title) return 1;
		return 0;
	}

	get searchParameter(): SearchParameter {
		this.parameters.searchString = this.searchControl.value;
		return this.parameters;
	}

	set searchParameter(searchParams: SearchParameter) {
		this.searchControl.setValue(searchParams.searchString);
		this.parameters = searchParams;
	}
}
